import { EMPTY_ARR } from '~/core/shared/constants';
import { SummaryContentComponentElement } from '~/core/shared/types';
import { ContactEntry } from '../elements/ContactCard/types';

export function parseContactContentElements(
  elements: SummaryContentComponentElement[],
): ContactEntry[] {
  return elements
    .filter((e) => e.format === 'contact')
    .flatMap((e) => {
      try {
        const parsed = JSON.parse(e.value);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch {
        return EMPTY_ARR;
      }
    });
}
